import { Component, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'delete-dialog',
    template: `<mat-dialog-content>
	<div class="row">
		<div class="col-xs-2 col-sm-1 messaging-icon"><i class="inline-icon fas fa-2x warning"></i></div>
		<div class="col-xs-10 col-sm">{{dialogText}}</div>
	</div>
</mat-dialog-content>

<div mat-dialog-actions>
    <div class="action-buttons">
        <button mat-stroked-button class="small-button secondary-action" color="primary" (click)="onCancel()">{{cancelText}}</button>
        <button mat-raised-button class="small-button" class="negative-action" color="primary" (click)="onConfirm()" cdkFocusInitial>{{buttonText}}</button>
    </div>
</div>`
})
export class DeleteDialog {
    @Input() dialogText: string;
    @Input() buttonText: string;
    @Input() cancelText: string;
    constructor(public dialogRef: MatDialogRef<DeleteDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        if (!this.dialogText) {
            this.dialogText = data.dialogText;
        }
        if (!this.buttonText) {
            this.buttonText = data.buttonText;
        }
        if (!this.cancelText) {
            this.cancelText = data.cancelText;
        }
    }
    onCancel(): void {
        this.dialogRef.close({ confirm: false });
    }
    onConfirm(): void {
        this.dialogRef.close({ confirm: true });
    }
}
